/* eslint-disable */
import React from 'react';


function TableHead(props) {
	return <div className={props.className}>{props.children}</div>;
}

export default TableHead;